module.exports = __webpack_public_path__ + "static/media/mitmZine.66ec23b0.png";